import { useData } from "./DataContext.js";

import { Transition } from "react-transition-group";

import Badge from "react-bootstrap/Badge";

const smallStyle = { width: "80px"}; //, backgroundColor: "#6f42c1" };

export default function ReliabilityBadge (props)
{
    const gData = useData();

    let badge = (<></>);
    
    const result = gData.state.reports[props.solutionId].result;

    if (result === null)
	badge = (<Badge bg="warning" text="dark" className={"w-100 border-0 d-inline-flex opacity-0"}/>);

    else {
	if (props.big)
	{
	    badge = (
		<Badge bg="warning" text="dark" className={"w-100 border-0 border-dark d-inline-flex justify-content-center align-items-center px-3 py-1 gap-2 text-uppercase"}>
		    <div className="fs-6 small fw-normal">Fiabilité</div>
		    <div className="fs-4">{Math.round(result.reliability / result.maxReliability * 100)}%</div>
		</Badge>
	    );
	}

	else {
	    badge = (
		<Badge bg="warning" text="dark" className={"w-100 border-0 border-dark d-inline-flex flex-column justify-content-center align-items-center gap-0 text-uppercase"}>
		    <div className="fs-7 small fw-normal">Fiabilité</div>
		    <div className="fs-6">{Math.round(result.reliability / result.maxReliability * 100)}%</div>
		</Badge>
	    );
	}
    }
    
    return (
	<Transition timeout={500} in={result}>
	    {(state) => (<div className={"d-inline-flex pop-in-"+state} style={smallStyle}>{badge}</div>)}
	</Transition>
    );
}
